import type { RuleSet } from 'styled-components';
import { css } from 'styled-components';

type QueryOptions =
  | {
      max?: number;
      min: number;
    }
  | {
      max: number;
      min?: number;
    };

/**
 * Generates a media query containing the provided CSS. Requires passing in
 * either a minimum width, maximum width or both.
 * @param options.min The minimum width to use for the media query.
 * @param options.max The maximum width to use for the media query.
 * @param styles The css to insert into the media query. This should be
 * created using the `css` helper from styled-components.
 */
export const mediaQuery = ({ max, min }: QueryOptions, styles: RuleSet<object>) => {
  const fromQuery = (size?: number) => (size ? `and (min-width: ${size}px)` : '');
  const toQuery = (size?: number) => (size ? `and (max-width: ${size}px)` : '');

  return css`
    @media only screen ${fromQuery(min)} ${toQuery(max)} {
      ${styles}
    }
  `;
};
